import { Box, Container, Typography } from '@mui/material';
import Video from 'components/Video';
import LazyLoad from 'react-lazyload';
import NextLink from 'next/link';
import CustomButton from 'components/CustomButton';
import { useStyles } from './styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export default function BuildPresentationsMobile() {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor={COLOR_PURPLE} py={3}>
        <Container>
          <Typography className={classes.title} component="h2">
            <b>
              Build stunning presentations for <br /> speeches and webinars
            </b>
          </Typography>

          <Box py={2} display="flex" justifyContent="center">
            <Typography className={classes.textDescription} variant="body1" component="p">
              Create the most amazing presentations for <br />
              speeches and webinars in a blink of an eye. Just <br /> drag and drop elements into
              the workspace to <br /> build stunning designs almost instantly. Save time <br /> with
              Mind the Graph.
            </Typography>
          </Box>

          <Box className={classes.videoWrapper} textAlign="center">
            <LazyLoad offset={50}>
              <Video
                className={classes.video}
                sources={[
                  { src: '/videos/new-header-banner-new-workspace.webm', type: 'video/webm' },
                ]}
              />
            </LazyLoad>
          </Box>

          <Box textAlign="center" pt={3}>
            <NextLink href={`/institutions/book-a-demo`} passHref={true}>
              <CustomButton variant="buttonWhiteTextPurple">
                Create Presentations Faster
              </CustomButton>
            </NextLink>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}
